import React, { useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { useDispatch } from 'react-redux';
import {
  REVIEW_CYCLE_STEPS_V1,
  resetReviewCreation,
  setReviewCreationStep,
  setReviewCycleId,
  useReviewCreationData,
} from 'reducers/reviewCreationSlice';
import useRouteQueryParams from 'screens/performanceReview/hooks/useRouteQueryParams';
import { checkDemoReviewCreationTriggeredReviewsEnabled, checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { routes } from 'constants/routes';

import { useGetReviewTypeAndDetails } from './Hooks/dataHooks/reviewTypeAndDetailsDataHooks';
import { ReviewCreationHeader } from './ReviewCreationHeader';
import { Calibration } from './Steps/Calibration/Calibration';
import { Elements } from './Steps/Elements/Elements';
import { FormFillingExperience } from './Steps/FormFillingExperience/FormFillingExperience';
import { ReviewTypeAndDetails } from './Steps/ReviewTypeAndDetails';
import { ReviewTypeAndDetailsDemo } from './Steps/ReviewTypeAndDetailsDemo';
import { Reviewees } from './Steps/Reviewees/Reviewees';
import { Reviewers } from './Steps/Reviewers/Reviewers';
import { ShareResults } from './Steps/ShareResults/ShareResults';
import { Summary } from './Steps/Summary/Summary';
import { Timelines } from './Steps/Timelines/Timelines';
import { Validation } from './Steps/Validation/Validation';

const StepContent = () => {
  const { step } = useReviewCreationData();

  const isDemoCreation = checkDemoReviewCreationTriggeredReviewsEnabled();

  switch (step) {
    case REVIEW_CYCLE_STEPS_V1.NAME:
      return isDemoCreation ? <ReviewTypeAndDetailsDemo /> : <ReviewTypeAndDetails />;
    case REVIEW_CYCLE_STEPS_V1.REVIEWEES:
      return <Reviewees />;
    case REVIEW_CYCLE_STEPS_V1.REVIEWERS:
      return <Reviewers />;
    case REVIEW_CYCLE_STEPS_V1.ELEMENTS:
      return <Elements />;
    case REVIEW_CYCLE_STEPS_V1.FORM_FILLING_EXPERIENCE:
      return <FormFillingExperience />;
    case REVIEW_CYCLE_STEPS_V1.CALIBRATION:
      return <Calibration />;
    case REVIEW_CYCLE_STEPS_V1.SHARE_RESULTS:
      return <ShareResults />;
    case REVIEW_CYCLE_STEPS_V1.TIMELINES:
      return <Timelines />;
    case REVIEW_CYCLE_STEPS_V1.VALIDATION:
      return <Validation />;
    case REVIEW_CYCLE_STEPS_V1.SUMMARY:
      return <Summary />;
    default:
      return null;
  }
};

const ReviewProcessV1 = () => {
  const { formId, step } = useRouteQueryParams([
    routes.settings.review.reviewCycle,
    staticRoutesWithCustomSidebar.reviewCycleCreation,
  ]);
  const { reviewCycleId } = useReviewCreationData();

  useGetReviewTypeAndDetails({ reviewCycleId });

  const dispatch = useDispatch();

  useEffect(() => {
    formId && formId !== 'new' && dispatch(setReviewCycleId(formId));
    dispatch(setReviewCreationStep(step));
  }, [dispatch, formId, step]);

  useEffect(
    () => () => {
      dispatch(resetReviewCreation());
    },
    [dispatch]
  );

  return (
    <>
      <ReviewCreationHeader />
      <Flex flexDir="column" overflowY="auto" p={checkNewNavEnabled() ? '1px' : 4} gap={3} pb="84px">
        <StepContent key={step} />
      </Flex>
    </>
  );
};

export { ReviewProcessV1 };
